import axios from '../../../api/apiClient';
import { FEATURES } from '../../../config/features';
import { SALARYTYPES } from '../../../utils/enums';
import { token, domain } from '../../Security';


// Lookup Services
export const fetchDataForLocation = async () => {
  const apiUrl = domain + "/api/Location/active";

  try {
    const response = await axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    })
    return response.data;
  } catch (error) {
    console.error('[fetchDataForLocation] Error fetching data:', error);
    return [];
  }
};
export const fetchDataForEmployment = async () => {
  const apiUrl = domain + "/api/Employment/active";

  try {
    const response = await axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    })
    return response.data;
  } catch (error) {
    console.error('[fetchDataForEmployment] Error fetching data:', error);
    return [];
  }
};
export const fetchDataForDepartment = async () => {
  const apiUrl = domain + "/api/Department/active";

  try {
    const response = await axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('[fetchDataForDepartment] Error fetching data:', error);
    return [];
  }
};
export const fetchDataForSection = async () => {
  const apiUrl = domain + "/api/Section/active";

  try {
    const response = await axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    })
    return response.data;
  } catch (error) {
    console.error('[fetchDataForSection] Error fetching data:', error);
    return [];
  }
};
export const fetchDataForClassification = async () => {
  const apiUrl = domain + "/api/Classification/active";

  try {
    const response = await axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    })
    return response.data;
  } catch (error) {
    console.error('[fetchDataForClassification] Error fetching data:', error);
    return [];
  }
};
export const fetchDataForPaytype = async () => {
  const apiUrl = domain + "/api/Paytype/active";

  try {
    const response = await axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    })
    return response.data;
  } catch (error) {
    console.error('[fetchDataForPaytype] Error fetching data:', error);
    return [];
  }
};
export const fetchDataForShiftSchedule = async () => {
  const apiUrl = domain + "/api/ShiftSchedule/";

  try {
    const response = await axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    })
    return response.data;
  } catch (error) {
    console.error('[fetchDataForShiftSchedule] Error fetching data:', error);
    return [];
  }
};
export const fetchDataForPosition = async () => {
  const apiUrl = domain + "/api/Position/active";

  try {
    const response = await axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching position data:', error);
    return [];
  }
};
export const fetchDataForCompany = async () => {
  const apiUrl = domain + "/api/Company/active";

  try {
    const response = await axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching company data:', error);
    return [];
  }
};
export const fetchDataForJobTitle = async () => {
  const apiUrl = domain + "/api/JobTitle/active";

  try {
    const response = await axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching job title data:', error);
    return [];
  }
};
export const fetchDataPositionDesignationSalary = async () => {
  const apiUrl = domain + "/api/PositionDesignationSalary";

  try {
    const response = await axios.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching position designation salary:", error);
    return [];
  }
};
export const fetchDataEmployeeDailySalary = async () => {
  const apiUrl = domain + "/api/EmployeeDailySalary";

  try {
    const response = await axios.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching employee daily salary:", error);
    return [];
  }
};
export const fetchDataEmployeeSalary = async () => {
  const apiUrl = domain + "/api/EmployeeSalary";

  try {
    const response = await axios.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching employee salary:", error);
    return [];
  }
};
export const fetchDataQuotaBasedSalary = async () => {
  const apiUrl = domain + "/api/QuotaBasedSalary";

  try {
    const response = await axios.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching quota based salary:", error);
    return [];
  }
};
export const fetchDataForEmployeeGroup1 = async () => {
  const apiUrl = domain + "/api/EmployeeGroup1/active";

  try {
    const response = await axios.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching employee group 1 data:", error);
    return [];
  }
};
export const fetchDataForEmployeeGroup2 = async () => {
  const apiUrl = domain + "/api/EmployeeGroup2/active";

  try {
    const response = await axios.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching employee group 2 data:", error);
    return [];
  }
};
export const fetchDataForPlantilya = async () => {
  const apiUrl = domain + "/api/Plantilya/active";

  try {
    const response = await axios.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching plantilya data:", error);
    return [];
  }
};
export const fetchDataForCostCenter = async () => {
  const apiUrl = domain + "/api/CostCenter/active";

  try {
    const response = await axios.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching cost center data:", error);
    return [];
  }
};
export const fetchDataForClient = async () => {
  const apiUrl = domain + "/api/Client/active";

  try {
    const response = await axios.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching client data:", error);
    return [];
  }
};
export const fetchDataForEmployeeType = async () => {
  const apiUrl = domain + "/api/EmployeeType/active";

  try {
    const response = await axios.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching employee type data:", error);
    return [];
  }
};
export const fetchDataEmployeeTypesEligibleForPartialSalary = async () => {
  const apiUrl = domain + "/api/EmployeeType/eligible-for-partial-salary";

  try {
    const response = await axios.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching employee type data:", error);
    return [];
  }
};
export const fetchDataForVessel = async () => {
  const apiUrl = domain + "/api/Vessel/active";

  try {
    const response = await axios.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching vessel data:", error);
    return [];
  }
};
export const fetchDataForDestination = async () => {
  const apiUrl = domain + "/api/Destination/active";

  try {
    const response = await axios.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching destination data:", error);
    return [];
  }
};
export const fetchCrewList = async () => {
  const apiUrl = domain + "/api/EmployeeTransaction/crew-list";
  try {
    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching crew list:", error);
    return [];
  }
};
export const fetchCrewByVessel = async (vesselId) => {
  const apiUrl = domain + `/api/EmployeeTransaction/crew-list/${vesselId}`;
  try {
    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching crew by vessel:", error);
    return [];
  }
};
export const fetchDataDistantWater = async () => {
  const apiUrl = domain + "/api/DistantWater/active";
  try {
    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching active distant water data:", error);
    return [];
  }
};
export const fetchDataAreaOfOperation = async () => {
  const apiUrl = domain + "/api/AreaOfOperation/active";
  try {
    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching active area of operation data:", error);
    return [];
  }
};
export const fetchDataSubArea = async () => {
  const apiUrl = domain + "/api/SubArea/active";
  try {
    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching active sub area data:", error);
    return [];
  }
};
export const fetchDataVesselFunction = async () => {
  const apiUrl = domain + "/api/VesselFunction/active";
  try {
    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching active vessel function data:", error);
    return [];
  }
};

export const fetchSalaryType = () => {
  return Object.values(SALARYTYPES);
};

export const fetchMonths = () => {
  return [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ];
};


// Detail & Account Services

export const fetchDataEmployeeById = async (id) => {
  const apiUrl = domain + "/api/Employee/";
  try {
    const response = await axios.get(apiUrl + `${id}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    return response.data;

  } catch (error) {
    console.error('[fetchDataEmployeeById] Error fetching data:', error);
    return [];
  }
};
export const fetchDataEmployeeTrainingById = async (id) => {
  const apiUrl = domain + "/api/Employee/trainings-seminar/id/";
  try {
    const response = await axios.get(apiUrl + `${id}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    return response.data;

  } catch (error) {
    console.error('[fetchDataEmployeeTrainingById] Error fetching data:', error);
    return [];
  }
};
// Ensure you import the base API calls here if they aren't already available
// import { fetchDataEmployeeById, fetchDataEmployeeTrainingById } from ...; 

export const fetchFullEmployeeDetails = async (employeePersonalInformationId) => {
  // 1. Fetch Basic Info
  const employeeInfo = await fetchDataEmployeeById(employeePersonalInformationId);

  if (!employeeInfo) {
    throw new Error("Employee not found");
  }

  // 2. Fetch and Merge Training Files
  // (This logic is copied exactly from your component)
  const updatedTrainings = await Promise.all(
    employeeInfo.employeeTrainingSeminars.map(async (empTraining) => {
      try {
        const trainingDetail = await fetchDataEmployeeTrainingById(empTraining.id);

        // Normalize: always get a single object
        const detail = Array.isArray(trainingDetail)
          ? trainingDetail.find(t => t.id === empTraining.id)
          : trainingDetail;

        return {
          ...empTraining,
          file: detail?.file || null,
          fileName: detail?.fileName || null,
        };
      } catch (error) {
        console.warn(`Error fetching training details for ID ${empTraining.id}:`, error);
        // Return training without file on error, don't break the whole page
        return { ...empTraining, file: null };
      }
    })
  );

  // 3. Return the fully constructed object
  return {
    ...employeeInfo,
    employeeTrainingSeminars: updatedTrainings,
  };
};

export const fetchDataAccessTemplate = async () => {
  try {
    const apiUrl = domain + "/api/AccessTemplate";

    const response = await axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json' // You can include other headers if needed
      }
    })
    return response.data;
  } catch (error) {
    console.error('[fetchDataAccessTemplate] Error fetching data: ', error)
    return [];
  }
};
export const fetchDataAccounts = async () => {
  const apiUrl = domain + "/api/Authentication";
  try {
    const response = await axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('[fetchDataAccounts] Error fetching data:', error);
    return [];
  }
};
export const fetchDataEmployeeInfoForMasterlist = async (filters) => {
  const apiUrl = domain + `/api/Employee/masterlist/filters`;

  const _filters = filters.map((f) => ({
    type: f.type,
    value: f.value
  }));

  try {
    const response = await axios.post(apiUrl, _filters, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('[fetchDataEmployeeInfoForMasterlist] Error fetching data:', error);
    return [];
  }
};
export const fetchDataEmployeeInformationOnly = async (filters) => {
  const apiUrl = domain + `/api/Employee/employee-information-only/filters`;

  const _filters = filters.map((f) => ({
    type: f.type,
    value: f.value
  }));

  try {
    const response = await axios.post(apiUrl, _filters, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    })
    return response.data;
  } catch (error) {
    console.error('[fetchDataEmployeeInformationOnly] Error fetching data:', error);
    return []
  }
};
export const fetchAllEmployeeSingleData = async () => {
  const apiUrl = domain + `/api/Employee/single-data`;

  try {
    const response = await axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('[fetchAllEmployeeSingleData] Error fetching data:', error);
    return [];
  }
};
export const fetchAllEmployeeStatusMaintenanceData = async () => {
  const apiUrl = domain + `/api/EmployeeStatusMaintenance`;

  try {
    const response = await axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('[fetchAllEmployeetatusMaintenanceData] Error fetching data:', error);
    return [];
  }
};